<template>
  <div>

    <div class="categories-container">
      <h4 class="categories-title">Categories</h4>

      <b-card-group deck class="categories-deck">
        <b-card
          v-if="false"
          title="My Profile"
          :img-src="myProfileImg"
          img-alt="My Profile"
          img-top
          class="text-center"
          @click="$emit('navigate', 'Profile'); showTheContentOfThisCategory('My Profile');"
        >
        </b-card>
        <b-card
          title="My Subscription"
          :img-src="mySubscriptionImg"
          img-alt="My subscription"
          img-top
          class="text-center"
          @click="$emit('navigate', 'SubscriptionDetails'); showTheContentOfThisCategory('My Subscription');"
        >
        </b-card>
        <b-card
          title="Billing Details"
          :img-src="billingDetailsImg"
          img-alt="Billing Details"
          img-top
          class="Essential Oil text-center"
          @click="$emit('navigate', 'Billing'); showTheContentOfThisCategory('Billing Details');"
        >
        </b-card>
        <b-card
          title="Invoices"
          :img-src="invoicesImg"
          img-alt="Invoices"
          img-top
          class="text-center"
          @click="$emit('navigate', 'Invoices'); showTheContentOfThisCategory('Invoices');"
        >
        </b-card>
      </b-card-group>
    </div>

  </div>
</template>

<script>
import myProfile from "@/assets/images/centre/my-account/MyProfile.png";
import mySubscription from "@/assets/images/centre/my-account/MySubscription.png";
import billingDetails from "@/assets/images/centre/my-account/BillingDetails.png";
import myInvoices from "@/assets/images/centre/my-account/Invoices.png";

export default {
  name: "MyAccountCategoriesCards",
  data() {
    return {
      myProfileImg: myProfile,
      mySubscriptionImg: mySubscription,
      billingDetailsImg: billingDetails,
      invoicesImg: myInvoices,

      showMyProfile: false,
      showSubscriptionDetails: false,
      showBillingDetails: false,
      showInvoices: false,
    }
  },
  methods: {
    showTheContentOfThisCategory: function(category) {
      this.changeTheStatusOfAllCategoriesTo(false);
      if (category === 'My Profile') {
        this.showMyProfile = true;
      } else if (category === 'My Subscription') {
        this.showSubscriptionDetails = true;
      } else if (category === 'Billing Details') {
        this.showBillingDetails = true;
      } else if (category === 'Invoices') {
        this.showInvoices = true;
      }
    },
    changeTheStatusOfAllCategoriesTo(showOrNot) {
      this.showMyProfile = showOrNot;
      this.showSubscriptionDetails = showOrNot;
      this.showBillingDetails = showOrNot;
      this.showInvoices = showOrNot;
    }
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
  transition: all .2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: flex;

    .card {
      margin-bottom: 0;
    }

    .card-img-top {
      max-width: 100%;
      height: auto;
      padding: 0.3rem;
      background-color: transparent;

    }

    h4.card-title {
      font-size: 10px;
    }
  }
}
</style>
